import { PaletteOptions } from '@mui/material/styles';
import { StatusPallette } from '@cnx-saas/polaris';
import { ShipmentStatus } from '@cnx-saas/shipment';

declare module '@mui/material/styles' {
  interface TypeLink {
    main: React.CSSProperties['color'];
  }

  interface TypeNeutral {
    main: React.CSSProperties['color'];
    light: React.CSSProperties['color'];
    lighter: React.CSSProperties['color'];
    button: React.CSSProperties['color'];
  }
  interface PaletteOptions {
    link?: TypeLink;
    neutral?: TypeNeutral;
    status?: StatusPallette;
  }

  interface Palette {
    link: TypeLink;
    neutral: TypeNeutral;
  }

  interface TypeBackground {
    special?: React.CSSProperties['color'];
  }

  interface TypeText {
    grey: React.CSSProperties['color'];
  }

  interface PaletteColor {
    lighter?: React.CSSProperties['color'];
  }

  interface SimplePaletteColorOptions {
    lighter?: React.CSSProperties['color'];
  }
}

export const palette: PaletteOptions = {
  primary: {
    main: '#078850',
    light: '#D2E9DE',
    lighter: '#E9F4EF',
  },
  secondary: {
    main: '#045230',
  },
  background: {
    default: '#FFFFFF',
    paper: 'hsl(210, 40%, 98%)',
  },
  text: {
    primary: 'hsl(255, 7%, 11%)',
  },
  divider: 'hsla(0, 0%, 0%, 0.12)',
  neutral: {
    main: '#8E8D8F',
    light: '#F2F1F2',
    lighter: '#F9F9F9',
    button: 'hsl(240, 1%, 47%)',
  },
  success: {
    main: 'hsl(165, 100%, 37%)',
    dark: 'hsla(165, 100%, 37%, 0.17)',
    light: 'hsla(165, 100%, 37%, 0.08)',
  },
  error: {
    main: 'hsl(1, 83%, 63%)',
    light: 'hsla(1, 83%, 63%, 0.08)',
  },
  warning: {
    main: 'hsl(43, 86%, 51%)',
    light: 'hsla(43, 86%, 51%, 0.08)',
  },
  link: {
    main: 'hsl(187, 52%, 49%)',
  },
  info: {
    main: 'hsl(211, 90%, 45%)',
  },
  status: {
    [ShipmentStatus.ACCEPTED]: {
      light: 'hsl(155, 53%, 88%)',
      dark: 'hsl(155, 53%, 78%)',
      main: '#009959',
    },
    [ShipmentStatus.CREATED]: {
      light: 'hsla(13.333, 14%, 95%, 1)',
      dark: 'hsla(13.333, 14%, 85%, 1)',
      main: 'hsla(15.918, 25%, 38%, 1)',
    },
    [ShipmentStatus.REQUESTED]: {
      light: 'hsla(205, 100%, 95%, 1)',
      dark: 'hsla(205, 100%, 85%, 1)',
      main: '#004E96',
    },
    [ShipmentStatus.ALLOCATED]: {
      light: 'hsl(46, 100%, 90%)',
      dark: 'hsl(46, 100%, 80%)',
      main: '#CD9B04',
    },
    [ShipmentStatus.CANCELLED]: {
      main: 'hsl(240, 1%, 47%)',
      dark: 'hsl(30, 3%, 75%)',
      light: ' hsl(0, 1%, 85%)',
      // light: 'hsl(12, 100%, 95%)',
      // dark: 'hsl(12, 100%, 85%)',
      // main: '#AC0523',
    },
    [ShipmentStatus.IN_TRANSIT]: {
      light: 'hsl(202, 61%, 94%)',
      dark: 'hsl(202, 61%, 84%)',
      main: '#007BC2',
    },
    [ShipmentStatus.DELAYED]: {
      light: 'hsl(12, 100%, 95%)',
      dark: 'hsl(12, 100%, 85%)',
      main: '#AC0523',
    },
    [ShipmentStatus.COMPLETED]: {
      light: 'hsl(240, 100%, 96%)',
      dark: 'hsl(240, 100%, 86%)',
      main: '#5451C6',
    },
    [ShipmentStatus.REJECTED]: {
      light: 'hsl(12, 100%, 95%)',
      dark: 'hsl(12, 100%, 85%)',
      main: '#AC0523',
    },
    [ShipmentStatus.DELIVERED]: {
      light: 'hsl(155, 53%, 88%)',
      dark: 'hsl(155, 53%, 78%)',
      main: '#009959',
    },
  },
};
